import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Notification_ReadState } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { setNotificationReadState } from '~/services/api/fetchers/setNotificationReadState.api';
import { BlazeDeviceQueryKey } from '~/services/queryKeys';

interface UseSetNotificationReadStateParams {
  name: string;
  readState: Notification_ReadState;
}

export function useSetNotificationReadState() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name, readState }: UseSetNotificationReadStateParams) =>
      setNotificationReadState({ name, readState }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BlazeDeviceQueryKey.LIST_NOTIFICATIONS],
      });
    },
  });
}
